import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

export type StickerSize = 'default' | 'small' | 'xsmall';

const Container = styled.div`
  z-index: 5;
  padding: 0.2rem 1.2rem;

  background-color: ${({ color }) => (color ? pickColor(color as 'green') : pickColor('red'))};
  color: ${pickColor('white')};
  border-radius: 1.6rem;

  text-shadow: 0.1rem 0.1rem 0.1rem rgba(0, 0, 0, 0.2);
`;

const pickFontSize = (size?: StickerSize) => {
  switch (size) {
    case 'xsmall':
      return '0.8rem';
    case 'small':
      return '0.9rem';
    default:
      return '1rem';
  }
};

const pickLineHeight = (size?: StickerSize) => {
  switch (size) {
    case 'xsmall':
      return '1.4rem';
    case 'small':
      return '1.7rem';
    default:
      return '2rem';
  }
};

const Label = styled(Headline)<{ $size?: StickerSize }>`
  font-size: ${({ $size }) => pickFontSize($size)};
  line-height: ${({ $size }) => pickLineHeight($size)};
  letter-spacing: 1px;
`;

export { Container, Label };
